var _defs, _style, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 34",
    width: 24,
    height: 34,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 34,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAiCAMAAABySOkBAAAAAXNSR0IB2cksfwAAASBQTFRF////F2CII2yYIGmUHGWPF2CIHWeRIWqVJG6aJnCcIWuWGmOMHGaPJW6aLnemNH6uNoCxNH6vLninJG2ZG2SNG2SNJW6aHmeRL3moKHKfGWKLIGqVKHGeNX+wMHqpHGWPIGmTJG6aGWOLLXalMXurIGqVGWOLKnShGGGJIWqVJnCcJW+bGWKKMnurm8DY5/D2////M32uJW+bImyXH2iS2ujxIGmTIWqVHWeRKXKfKXOgGWKLMXuqNX+vIWuWNH2uGmSNJG2ZJnCcLnimJ3GdIWuWGmOMI22YGmOMG2WOKnSiI2yYM32tMnysJG6aMHmoF2GJJW+bH2iTK3WjGmOLHWaQJm+cJG2ZGGGKI22YImuWJW+bMHmpL3inJ3CdJ3Ge9ERXrwAAAGB0Uk5TAACb2/b/785vH7/9////////////+1f/////z//////acP///87+/////zz///////9Wrf///83u///+//////+FHf//vv+a/v//////bv//Ov///v//hv///1X/////IAQVHwAAAaNJREFUeJx1kttLAkEUxs9XmW7RDQoquiiioJU9GGVEhBYFRdBTD/2JEREUREJIJGUXgy4UoQ9aIEXWQ0a1LDbNjO7mrvYtO3P2/GbOmT1zQFwQL5ccVSKm+8iBChVUQcQq6mJ1+KaSWBOQ4wTiUTpQIEOtQJYYD+wEXqlSnU89aZ7N0Y9nMsvRrmaAQeWjYAHUm9YwBDzKjwEelbEHabueuxFEWtoeTU62lJy8QAh3cn1dOcqP3OP/wRRuhDUI/T+y8mBZ2ELXwnIaiTMSf8LWXagBhk/+CeU/R+g9VyN54AHB+4bq447yIkdUR7LqB8cu88DclWqtiKsLUSDcqCWtpXrJ8+qSMnNjriKUkSjj1xRW245MYGqvyC9KNMBCfbzCP53ybrPSndd7cxUgkNBYuUuWv+2Hhn8G2NIB2VqKBohcZPW+Iqyk3Adl/yzeYn+AlKVE6cgtvviX0Yl8DF97bqU1H8tLfxkQVvcnRf7pZrZuBjTh2uXz4oZW8uuAsBaL7NDymW+LkRnQeEYlu/OULECUzI3jvhgjK6DVTSoyfQP9Ah4Wi0BaaCfeAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.219ac5482e77d88691a918bf03c9e2b9.svg";
export { ForwardRef as ReactComponent };